import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "tradeOrganization",
  listPath: "trade/organization",
  adminPath: "trade/organization",
  legacy: {
    data: "tradeOrganization",
    count: "count",
    fetch: "fetchTradeOrganizations",
    create: "createOneTradeOrganization",
    update: "updateTradeOrganization",
    remove: "deleteTradeOrganization",
    updateState: "updateTradeOrganizationState",
  },
});

export const TradeOrganizationProvider = Provider;
export const useTradeOrganizationContext = useValue;
